import * as React from 'react';
import { RouteComponentProps } from 'react-router-dom';
import * as types from 'modules/types/smSupplierManagement';
// @ts-ignore
import _ from 'lodash';

export interface DetailProps extends RouteComponentProps {
  prefixCls: string;
  getDetail: Function;
  data: types.SupplierMangementDetail;
  auditItemsResult: { [k: string]: boolean };
  showSupplierContracts: boolean;
  readOnly?: boolean;
  getAttachementDownloadLink?: (attachId: number, withDownload?: boolean) => string;
}

const supplierDetailHOC = (WrappedComponent: any) => {
  return class extends React.Component<DetailProps, any> {
    public static defaultProps = {
      prefixCls: 'mpc-ext-company-info',
    };

    constructor(props: DetailProps) {
      super(props);
    }

    public componentDidMount() {
      const { getDetail } = this.props;
      getDetail().catch((err: any) => {
        return;
      });
    }

    public render() {
      return <WrappedComponent {...this.props} />;
    }
  };
};

export default supplierDetailHOC;
